import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { entrepotActions } from "../sagas/entrepotSlice";

export function useEntrepotFetch() {
  const dispatch = useDispatch();
  const { entrepots, loading: entrepotsLoading } = useSelector(state => state.entrepots);

  useEffect(() => {
    dispatch(entrepotActions.list());
  }, [dispatch]);

  const entrepotOptions = !entrepotsLoading ? (entrepots.filter(e => e.libelle !== 'EXTERNE' && e.libelle !== 'RETOUR') ?? [])?.map(entrepot => ({
    value: entrepot.id,
    label: entrepot.code + ' - ' + entrepot.libelle,
  })) : [];

  return { entrepots, entrepotsLoading, entrepotOptions };
}
